import { RouterManager } from '@aclass/admin/managers';
import { SplitTestStory } from '@aclass/admin/storage/actions';
import { IAdminState, ISplitTestModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class SplitTestViewStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:split-test-view';

    private id: string;

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<ISplitTestModuleState['viewPageRecordId']>(['splitTestModule', 'viewPageRecordId']).pipe(
            filter(v => v === this.id)
        );
        this.employee = this.routerManager.onRejectNavigation(SplitTestViewStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        this.id = route.params.id;
        this.ngRdx.dispatch(SplitTestStory.dryRunViewPage(this.id));
    }
}
